import { LinkWidget } from './linkWidget.jsx';

const props = [
    'backgroundImage',
    'headerText',
    'icon',
    'linkUrl',
    'widgetType'
];

export const LinkWidgetDirective = reactDirective => reactDirective(LinkWidget, props);
LinkWidgetDirective.$inject = ['reactDirective'];

angular.module('WB.App').directive('linkWidget', LinkWidgetDirective);
